import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { closeStatusPanel, openLicense } from '../actions.js';
import { APP_COMMIT, BUILD_DATE } from '../version.js';
import { iconMarkup } from '../icons/index.js';

function row(label, value, valueClass) {
  return h('div', { class: 'review-row' }, [
    h('span', { class: 'k' }, label),
    h('span', { class: valueClass ? 'v ' + valueClass : 'v' }, value)
  ]);
}

// Secure means online *and* the page itself was served over HTTPS (or is
// running from localhost in dev) — an online-but-plain-HTTP load shouldn't
// read as "secure".
function isSecureContext() {
  if (typeof location === 'undefined') return true;
  return location.protocol === 'https:' || location.hostname === 'localhost';
}

export function renderStatusPanel() {
  const s = getState();
  if (!s.showStatusPanel) return null;

  const workerLabel = s.workerConnected === null ? 'Checking…' : s.workerConnected ? 'Connected' : 'Not connected';
  const workerClass = s.workerConnected === false ? 'status-bad' : 'status-good';
  const networkLabel = s.online ? (isSecureContext() ? 'Online · Secure' : 'Online') : 'Offline';

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'Status'),
      h('div', { class: 'stack' }, [
        row('Network', networkLabel, s.online ? 'status-good' : 'status-bad'),
        row('Blockchains', workerLabel, workerClass),
        row('FX rates', '2 mins ago'),
        row('Uptime', '99.99%+'),
        row('Mode', s.testnetEnabled ? 'Testnet' : 'Mainnet', s.testnetEnabled ? undefined : 'status-bad'),
        row('Build', `${BUILD_DATE}#${APP_COMMIT}`),
        h('div', { class: 'review-row' }, [
          h('span', { class: 'k' }, 'License'),
          h('a', {
            class: 'v provider-link', href: '#',
            onclick: (e) => { e.preventDefault(); openLicense(); }
          }, [
            'MIT ',
            h('span', { class: 'inline-icon', html: iconMarkup('squareArrowOutUpRight', { size: 12 }) })
          ])
        ])
      ]),
      h('button', { class: 'btn btn-secondary', onclick: closeStatusPanel }, 'Close')
    ])
  ]);
}
